import React from 'react'
import { Icon } from 'semantic-ui-react'

const CornerIcons = ({size, one, two, colorOne, colorTwo, onClick, className, corner, circular}) => <Icon.Group className={className} onClick={onClick} size={size || 'large'}>
    {typeof one === 'object' ? one : <Icon circular={circular} name={one} color={colorOne}/>}
    {typeof two === 'object' ? two : <Icon className={((typeof corner === 'boolean') && !corner) ? undefined : "toTop"} corner={typeof corner !== 'undefined' ? corner : 'bottom right'} name={two} color={colorTwo} />}
</Icon.Group>
 
export default CornerIcons